<template>
  <v-container :class="($vuetify.breakpoint.xs) ? 'pa-0' : '' ">
    <v-app-bar app color="primary" dark >
      <v-btn icon @click="$router.go(-1)">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title v-text="$store.state.pageTitle"></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn dark class='primary darken-2' icon @click="createUser()">
        <v-icon >mdi-plus</v-icon>
      </v-btn>
    </v-app-bar>

    <v-card tile flat>
      <v-card-text>
        <v-row class="mb-6">
          <v-col xs="12" sm="4" cols="12">

            <v-menu v-model="datePicker" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field dense outlined :value="orderDateFormat" label="Order date" readonly v-bind="attrs" v-on="on">
                </v-text-field>
              </template>
              <v-date-picker no-title v-model="order.date" @change="datePicker = false"></v-date-picker>
            </v-menu>

            <v-select dense label="Courier" outlined :items="couriers" v-model="order.courier"></v-select>
            <v-text-field dense outlined label="Code Booking" v-model="order.booking"></v-text-field>

          </v-col>

          <v-col xs="9" sm="4" offset-sm="2" cols="9">
            <v-autocomplete outlined dense :items="filteredUsers" v-model="order.User" return-object label="Customer" item-value="id" item-text="UserProfile.name" v-if="!order.User.id" hide-details @change="getUserId(order.User.id)">
            </v-autocomplete>
            <div v-else>
              <div class="font-weight-bold">Customer:</div>
              <div class="font-weight-bold">{{ order.User.UserProfile.name }}</div>
              <div>{{ order.User.UserProfile.address }}, {{ order.User.UserProfile.city.city }}
                <span v-if="order.User.UserProfile.postCode">, {{ order.User.UserProfile.postCode }}</span>
              </div>
              <div class="font-weight-bold">{{ order.User.UserProfile.phone }}</div>
            </div>
          </v-col>
          <v-col xs="3" sm="2" cols="3" align-self="end">
            <v-btn icon small class="success" dark fab @click="addUser" v-if="!order.User.id">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
            <div v-else>
              <v-btn class="success ma-2" dark icon @click="resetOrderUser">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn class="success ma-2" dark icon @click="printLabel">
                <v-icon>mdi-printer</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>

        <v-simple-table class='grey lighten-4'>
          <thead>
            <tr>
              <th>Product Name</th>
              <th class="text-right">Quantity</th>
              <th class="text-right">Price</th>
              <th class="text-right">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,idx) in order.OrderItems" :key="item.id">
              <td>
                {{ item.productName }}<br>
                Serial: {{ item.serial }} - License {{ item.license }}
              </td>
              <td class="text-right">
                {{ item.quantity }}
              </td>
              <td class="text-right">
                {{ item.price }}
              </td>
              <td class="text-right">
                <v-btn color="red" icon @click="deleteItem(idx)"><v-icon>mdi-delete</v-icon></v-btn>
              </td>
            </tr>

            <tr>
              <td colspan="4">
                <v-btn block outlined color="success" @click="addLineitem">
                  <v-icon>mdi-plus</v-icon>Add product
                </v-btn>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="2" class="text-right font-weight-bold">
                TOTAL
              </td>
              <td class="text-right font-weight-bold">
                {{ order.amount }}
              </td>
            </tr>
          </tfoot>
        </v-simple-table>
      </v-card-text>
      <v-card-actions>
        <v-btn block color="primary" @click="saveOrder">{{ orderSaveBtn }}</v-btn>
      </v-card-actions>
    </v-card>

    <UserDialog ref="user" :user="order.User" @closeDialog="closeDialogUser"></UserDialog>
    <LineitemDialog ref="lineitem" :item="lineitem" @closeDialog="closeDialogLineitem"></LineitemDialog>


    <v-dialog class="prinIt"
      v-model="dialogPrintLabel" fullscreen
       :overlay="false"
    >
      <v-card>
        <v-card-text class="px-2 py-0">

          <div class="mb-2 black--text" style="font-size:14px;line-height: 1.4em;">
            <div class="font-weight-bold">Kepada: {{ order.User.UserProfile.name }}</div>
            <div>{{ order.User.UserProfile.address }} {{ order.User.UserProfile.city.city }}</div>
            <div>HP: {{ order.User.UserProfile.phone }}</div>
          </div>

          <v-simple-table class="mb-1" dense >
            <tbody>
              <tr v-for="(item, idx) in order.OrderItems" :key="idx">
                <td class="border-1  black--text px-0 text-center">Ser: {{ item.serial }} </td>
                <td class="border-1  black--text px-0 text-center">Lisensi: {{ item.license }} </td>
              </tr>
            </tbody>
          </v-simple-table>
          <v-simple-table dense>
            <tbody><tr>
              <td class="border-1 black--text  px-0 text-center">{{ order.courier }}</td>
              <td class="border-1  black--text px-0 text-center" v-if="order.booking">{{ order.orderItems[0].notes.booking }}</td>
            </tr></tbody>
          </v-simple-table>
          <v-divider class="my-3 black"></v-divider>
          <div class="text-right">
            Pengirim: jasmadigital.com<br>
            0812.2806.2725
          </div>

        </v-card-text>
      </v-card>
    </v-dialog>


  </v-container>
</template>

<script>
  import UserDialog from '@/components/nano/UserDialog'
  import LineitemDialog from '@/components/nano/LineitemDialog'
  export default {
    components: { UserDialog, LineitemDialog },
    data(){
      return {
        datePicker: false,
        order: { amount: 0, date: this.$moment().format('YYYY-MM-DD'), OrderItems: [], User:{ email:'', UserProfile: { city: '' } } },
        lineitem: { notes: {} },
        dialogPrintLabel: false,
        dialogDatePicker: false,
        couriers: [ 'TIKI Reg', 'TIKI ONS', 'JNE Reg', 'JNE YES', 'SiCepat', 'AnterAja', 'Pos Express' ]
      }
    },

    created(){

    },

    computed:{
      orderSaveBtn(){
        return (!this.order.id) ? 'Save' : 'Update'
      },
      filteredUsers(){
        return this.$store.state.users
      },

      orderAmount(){
        return this.order.OrderItems.reduce((a,b) => (a + b.price),0)
      },

      orderDateFormat(){
        return (this.order.date) ? this.$moment(this.order.date).format('L') : ''
      },

    },

    watch:{
      orderAmount(val){
        this.order.amount = val
      }
    },

    methods:{
      resetOrderUser(){
        this.order.User = { UserProfile: { city: { type: '' } } }
      },
      getOrder(){
        this.axios.get('/orders/' + this.$route.params.id).then( (res) => {
          this.order = res.data
        })
      },

      addUser(){
        this.$refs.user.dialogUser = true
      },

      getUserId(id){
        this.order.userId = id
      },

      closeDialogUser(user){
        this.$refs.user.dialogUser = false
        this.order.User = user
        this.$refs.user = { email: '', UserProfile: { city: { type: '' } } }
      },

      addLineitem(){
        this.$refs.lineitem.dialogLineitem = true
        // this.order.OrderItems.push({ quantity: 1 })
        // this.orderItemIndex = this.order.OrderItems.length - 1

        // this.lineitem = this.order.OrderItems[index]
        // this.lineitem.quantity = 1
        // this.lineitem.index = index
      },

      deleteItem(idx){
        this.order.OrderItems.splice(idx,1)
      },

      closeDialogLineitem(item){

        this.$refs.lineitem.dialogLineitem = false
        this.order.OrderItems.push(item)

      },

      saveOrder(){

        this.axios.post('/orders', this.order).then( () => {

        }).catch( () => {

        })
      },

      printLabel(){
        this.dialogPrintLabel = true
        setTimeout(() =>{
          window.print();
            this.dialogPrintLabel = false
        }, 200)

      }

    }
  }
</script>

<style scoped>
  .border-1 { border:1px solid #000; }

</style>